import { NewsFilter, GameType, NewsSource } from '../types'
import { GAMES, SOURCES } from '../config/sources'
import SearchBar from './SearchBar'

interface Props {
  filter: NewsFilter
  onGameChange: (games: GameType[]) => void
  onSourceChange: (sources: NewsSource[]) => void
  onKeywordChange: (keyword: string) => void
}

export default function FilterBar({ filter, onGameChange, onSourceChange, onKeywordChange }: Props) {
  const toggleGame = (game: GameType) => {
    if (game === 'all') {
      onGameChange(['all'])
    } else {
      const newGames = filter.games.includes(game)
        ? filter.games.filter(g => g !== game && g !== 'all')
        : [...filter.games.filter(g => g !== 'all'), game]
      onGameChange(newGames.length === 0 ? ['all'] : newGames)
    }
  }

  const toggleSource = (source: NewsSource) => {
    const newSources = filter.sources.includes(source)
      ? filter.sources.filter(s => s !== source)
      : [...filter.sources, source]
    onSourceChange(newSources)
  }

  return (
    <div className="mb-8 space-y-4">
      {/* Search Bar */}
      <SearchBar keyword={filter.keyword || ''} onKeywordChange={onKeywordChange} />

      {/* Game Filter */}
      <div className="bg-white/10 backdrop-blur-md rounded-xl p-4">
        <h3 className="text-white font-semibold mb-3">游戏筛选</h3>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => toggleGame('all')}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${
              filter.games.includes('all')
                ? 'bg-white text-purple-900'
                : 'bg-white/20 text-white hover:bg-white/30'
            }`}
          >
            全部
          </button>
          {Object.entries(GAMES).map(([key, game]) => (
            <button
              key={key}
              onClick={() => toggleGame(key as GameType)}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                filter.games.includes(key as GameType)
                  ? 'text-white'
                  : 'bg-white/20 text-white hover:bg-white/30'
              }`}
              style={{
                backgroundColor: filter.games.includes(key as GameType) ? game.color : undefined
              }}
            >
              {game.icon} {game.name}
            </button>
          ))}
        </div>
      </div>

      {/* Source Filter */}
      <div className="bg-white/10 backdrop-blur-md rounded-xl p-4">
        <h3 className="text-white font-semibold mb-3">来源筛选</h3>
        <div className="flex flex-wrap gap-2">
          {Object.entries(SOURCES).map(([key, source]) => (
            <button
              key={key}
              onClick={() => toggleSource(key as NewsSource)}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                filter.sources.includes(key as NewsSource)
                  ? 'text-white'
                  : 'bg-white/20 text-white hover:bg-white/30'
              }`}
              style={{
                backgroundColor: filter.sources.includes(key as NewsSource) ? source.color : undefined
              }}
            >
              {source.icon} {source.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
